import { getQueryFromUrl } from "@utils/helpers/getQueryFromUrl";

import ContentPageSelector from "../flowTab/ContentPageSelector";

export const CollectionComponent = () => {
  const type = getQueryFromUrl("type");
  const id = getQueryFromUrl("id");

  return (
    <div className="h-full w-full">
      <ContentPageSelector
        identifier={type?.replaceAll("-", ":").toUpperCase() || ""}
        pageId={id || ""}
      />
    </div>
  );
};
